import {
  isCourtManager,
  isOpeningManager,
} from 'containers/AppContainer/utils';
import { FEE_NOTE, FEE_NOTE_STEP } from 'containers/data-structure';
import { DOCUMENT } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/constants';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';
import validate from 'containers/services/validateForm';
import {
  DEFAULT_LINK_BENEFICIARY_CODE,
  DEFAULT_LINK_PROVIDER,
  DOCTOR_ITEM_TYPE,
  DOC_MESSAGES,
  LIMIT_DATE_INVOICE,
  PAYMENT_NATURE_COSTS,
  PROCEDURE_STEPS,
  PROCEDURE_STEPS_MESSAGE,
  STATUS_PENDING,
  STATUS_REJECTED,
  STATUS_VALIDATED,
} from 'containers/LawyerFeeNote/constants';
import { translate } from 'containers/services/translate';
import currentUserStorage from 'containers/services/security/current-user-storage';
import messages from 'containers/LawyerFeeNote/messages';
import { get, isNull, isNil, isEmpty } from 'lodash';
import { Listings, SagisConfig } from 'containers/AppContainer/typings';
import { DOCUMENT_TYPES } from 'constants/global';
import moment from 'moment-timezone';
import {
  DEFAULT_PROVIDER_CODE,
  PROFIL_OPENNER_GPO,
} from 'containers/RecapPage/canstants';
import { isTransactionManager } from 'helpers/utils';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';
import { FeeNoteType } from 'typings/globalTypes';
import { GLOBAL_STATUS } from 'services/constants';
import { requestUtils } from 'helpers/saga-helpers';

const stringSize = 4;
export const zeroPad = (num: number) =>
  num ? String(num).padStart(stringSize, '0') : '';

export const dhAmount = (num: number) => {
  return num ? separateNumbers(num, ' ') + ' Dhs' : '0 Dhs';
};

function separateNumbers(x: number, separator: string) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
}

export const setColor = (status: string) => {
  let color = 'red'; // REJECTED
  if (status === STATUS_PENDING) color = 'orange';
  if (status === STATUS_VALIDATED) color = 'green';
  return color;
};

export const couldDoActionOn = (step: string, isManager: boolean) => {
  const decisionForOpening: boolean =
    isManager && isOpeningManager() && step === PROCEDURE_STEPS.PV;
  // Opening manager could only act when fee notes step is PV
  const decisionForCourt: boolean =
    isManager &&
    (isCourtManager() || isTransactionManager()) &&
    step !== PROCEDURE_STEPS.PV;
  // Opening manager could only act when fee notes step is  not PV
  return decisionForOpening || decisionForCourt;
};
export const isRejectedOrPendingStep = (row: any) => {
  if (
    ((get(row, 'step') === 'PV' &&
      get(row, 'claim.status') === STATUS_REJECTED) ||
      (get(row, 'step') === 'PV' &&
        get(row, 'claim.status', '') === 'PENDING') ||
      (!isNil(get(row, 'judgementAddDocument.status', null)) &&
        get(row, 'judgementAddDocument.status', '') === 'PENDING') ||
      (!isNil(
        get(row, 'judgementAddDocument.JudgementAdd.judgementAdd.status', null),
      ) &&
        (isNil(get(row, 'judgementAddDocument.status', null)) ||
          get(row, 'judgementAddDocument.status', null) === '') &&
        get(
          row,
          'judgementAddDocument.JudgementAdd.judgementAdd.status',
          '',
        ) === 'PENDING') ||
      (!isNil(get(row, 'feeNoteMission.missionExpertiseVictim.status', null)) &&
        (get(row, 'feeNoteMission.missionExpertiseVictim.status', null) ===
          'PENDING' ||
          get(row, 'feeNoteMission.missionExpertiseVictim.status', null) ===
            'REJECTED' ||
          get(row, 'feeNoteMission.missionExpertiseVictim.status', null) ===
            'PENDING_APPRECIATION')) ||
      (!isNil(
        get(row, 'feeNoteMission.missionExpertiseVehicle.status', null),
      ) &&
        (get(row, 'feeNoteMission.missionExpertiseVehicle.status', null) ===
          'PENDING' ||
          get(row, 'feeNoteMission.missionExpertiseVehicle.status', null) ===
            'REJECTED' ||
          get(row, 'feeNoteMission.missionExpertiseVehicle.status', null) ===
            'PENDING_APPRECIATION')) ||
      (!isNil(get(row, 'feeNoteMission.missionPostPone.status', null)) &&
        (get(row, 'feeNoteMission.missionPostPone.status', null) ===
          'PENDING' ||
          get(row, 'feeNoteMission.missionPostPone.status', null) ===
            'REJECTED')) ||
      (!isNull(
        get(row, 'judgementAddDocument.JudgementAdd.judgementAdd.status', null),
      ) &&
        (isNil(get(row, 'judgementAddDocument.status', null)) ||
          get(row, 'judgementAddDocument.status', null) === '') &&
        get(
          row,
          'judgementAddDocument.JudgementAdd.judgementAdd.status',
          '',
        ) === 'TO_EDIT') ||
      (!isNull(get(row, 'judgementAddDocument.status', null)) &&
        get(row, 'judgementAddDocument.status', null) === STATUS_REJECTED) ||
      get(row, 'judgement.status', '') === 'PENDING' ||
      get(row, 'judgement.status', '') === 'REJECTED' ||
      (get(row, 'judgement.status', null) === 'TO_EDIT' &&
        (isNil(get(row, 'judgementAddDocument.status', null)) ||
          get(row, 'judgementAddDocument.status', null) === ''))) &&
    get(row, 'status', '') === 'PENDING'
  ) {
    return true;
  } else {
    return false;
  }
};

export const isRejectedStep = (row: any) => {
  if (
    (get(row, 'step') === 'PV' &&
      get(row, 'claim.status') === STATUS_REJECTED) ||
    (!isNil(get(row, 'feeNoteMission.missionExpertiseVictim.status', null)) &&
      get(row, 'feeNoteMission.missionExpertiseVictim.status', null) ===
        'REJECTED') ||
    (!isNil(get(row, 'feeNoteMission.missionExpertiseVehicle.status', null)) &&
      get(row, 'feeNoteMission.missionExpertiseVehicle.status', null) ===
        'REJECTED') ||
    (!isNil(get(row, 'feeNoteMission.missionPostPone.status', null)) &&
      get(row, 'feeNoteMission.missionPostPone.status', null) === 'REJECTED') ||
    (!isNull(
      get(row, 'judgementAddDocument.JudgementAdd.judgementAdd.status', null),
    ) &&
      get(row, 'judgementAddDocument.JudgementAdd.judgementAdd.status', '') ===
        'TO_EDIT') ||
    (!isNull(get(row, 'judgementAddDocument.status', null)) &&
      get(row, 'judgementAddDocument.status', null) === STATUS_REJECTED) ||
    get(row, 'judgement.status', '') === 'REJECTED' ||
    get(row, 'judgement.status', null) === 'TO_EDIT'
  ) {
    return true;
  } else {
    return false;
  }
};
export const feeNoteValidationValidator = (feeNote: any) => {
  return validate(feeNote, {
    [FEE_NOTE.AMOUNT_TTC]: {
      presence: isNil(get(feeNote, 'costs', null)),
    },
    [FEE_NOTE.AMOUNT_HT]: {
      presence: isNil(get(feeNote, 'costs', null)),
    },
    [FEE_NOTE.CLAIM]: {
      presence: true,
    },
    [FEE_NOTE.COSTS]: {
      presence: true,
    },
    [FEE_NOTE.DOCUMENT]: {
      presence: true,
    },
    [FEE_NOTE.DOCUMENT_TYPE]: {
      presence: true,
    },
  });
};
export const stepWithDocumentType = (
  procedureType: any,
  document: any,
  props: any,
) =>
  `${translate(
    {
      ...get(PROCEDURE_STEPS_MESSAGE, procedureType, messages.invalidStep),
    },
    props,
  )}/${translate(
    { ...get(DOC_MESSAGES, document.type, messages.invalidStep) },
    props,
  )}`;

export const stepWithoutDocument = (procedureType: any, props: any) =>
  translate(
    {
      ...get(PROCEDURE_STEPS_MESSAGE, procedureType, messages.invalidStep),
    },
    props,
  );

export const getPaymentInfoFeeNote = (listings: Listings) => {
  return {
    PaymentNatureCode: get(
      get(listings, 'PaymentNature').find(
        (el: SagisConfig) => el.ItemKey === '3',
      ),
      'ItemKey',
    ),
    PaymentChannelCode: get(
      get(listings, 'PaymentChannel').find(
        (el: SagisConfig) => el.ItemKey === '6',
      ),
      'ItemKey',
    ),
  };
};

export const getPaymentForCosts = (listings: Listings, feeNote: any) => {
  const result = {
    PaymentNatureCode: get(
      get(listings, 'PaymentNature', []).find(
        (paymentNature: SagisConfig) =>
          paymentNature.ItemDescription === PAYMENT_NATURE_COSTS,
      ) || {},
      'ItemKey',
      '',
    ),
  };
  switch (get(feeNote, 'document.type', '')) {
    case getObjectKey(DOCUMENT_TYPES, DOCUMENT_TYPES.TAX):
      return Object.assign(
        {},
        { ...result },
        {
          PaymentChannelCode: get(
            get(listings, 'PaymentChannel', []).find(
              (paymentChannel: SagisConfig) =>
                paymentChannel.ItemDescription === DOCUMENT_TYPES.TAX,
            ) || {},
            'ItemKey',
            '',
          ),
        },
      );
    case getObjectKey(DOCUMENT_TYPES, DOCUMENT_TYPES.THUMBNAIL):
      return Object.assign(
        {},
        { ...result },
        {
          PaymentChannelCode: get(
            get(listings, 'PaymentChannel', []).find(
              (paymentChannel: SagisConfig) =>
                paymentChannel.ItemDescription === DOCUMENT_TYPES.THUMBNAIL,
            ) || {},
            'ItemKey',
            '',
          ),
        },
      );
    case getObjectKey(DOCUMENT_TYPES, DOCUMENT_TYPES.TRAVELLING_EXPENSES): {
      return Object.assign(
        {},
        { ...result },
        {
          PaymentChannelCode: get(
            get(listings, 'PaymentChannel', []).find(
              (paymentChannel: SagisConfig) =>
                paymentChannel.ItemDescription ===
                DOCUMENT_TYPES.TRAVELLING_EXPENSES,
            ) || {},
            'ItemKey',
            '',
          ),
        },
      );
    }
  }
  if (get(feeNote, 'step') === DOCUMENT_TYPES.PV && get(feeNote, 'costs')) {
    return Object.assign(
      {},
      { ...result },
      {
        PaymentChannelCode: get(
          get(listings, 'PaymentChannel', []).find(
            (paymentChannel: SagisConfig) =>
              paymentChannel.ItemDescription === DOCUMENT_TYPES.COUT_PV,
          ) || {},
          'ItemKey',
          '',
        ),
      },
    );
  }
  return result;
};
export const getObjectKey = (obj: any, value: string) => {
  return Object.keys(obj).find(key => obj[key] === value) || {};
};

export const displayReasonBlockFeeNoteDecision = (row: any, listings: any) => {
  if (
    ((get(row, 'step') === 'PV' &&
      get(row, 'claim.status') === STATUS_REJECTED) ||
      (!isNull(get(row, 'judgementAddDocument.status', null)) &&
        get(row, 'judgementAddDocument.status', null) === STATUS_REJECTED) ||
      get(row, 'judgement.status', '') === STATUS_REJECTED ||
      (get(row, 'judgement.status', null) === 'TO_EDIT' &&
        (isNil(get(row, 'judgementAddDocument.status', null)) ||
          get(row, 'judgementAddDocument.status', null) != '')) ||
      (!isNull(
        get(row, 'judgementAddDocument.JudgementAdd.judgementAdd.status', null),
      ) &&
        (isNil(get(row, 'judgementAddDocument.status', null)) ||
          get(row, 'judgementAddDocument.status', null) === '') &&
        get(
          row,
          'judgementAddDocument.JudgementAdd.judgementAdd.status',
          '',
        ) === 'TO_EDIT')) &&
    get(row, 'status', '') === 'PENDING'
  ) {
    return 'ETAPE REJETEE';
  } else if (
    ((get(row, 'step') === 'PV' &&
      get(row, 'claim.status', '') === 'PENDING') ||
      (!isNull(get(row, 'judgementAddDocument.status', null)) &&
        get(row, 'judgementAddDocument.status', '') === 'PENDING') ||
      get(row, 'judgement.status', '') === 'PENDING' ||
      (!isNil(
        get(row, 'judgementAddDocument.JudgementAdd.judgementAdd.status', null),
      ) &&
        (isNil(get(row, 'judgementAddDocument.status', null)) ||
          get(row, 'judgementAddDocument.status', null) === '') &&
        get(
          row,
          'judgementAddDocument.JudgementAdd.judgementAdd.status',
          '',
        ) === 'PENDING') ||
      (!isNil(get(row, 'feeNoteMission.missionExpertiseVictim.status', null)) &&
        (get(row, 'feeNoteMission.missionExpertiseVictim.status', null) ===
          'PENDING' ||
          get(row, 'feeNoteMission.missionExpertiseVictim.status', null) ===
            'PENDING_APPRECIATION')) ||
      (!isNil(
        get(row, 'feeNoteMission.missionExpertiseVehicle.status', null),
      ) &&
        (get(row, 'feeNoteMission.missionExpertiseVehicle.status', null) ===
          'PENDING' ||
          get(row, 'feeNoteMission.missionExpertiseVehicle.status', null) ===
            'PENDING_APPRECIATION')) ||
      (!isNil(get(row, 'feeNoteMission.missionPostPone.status', null)) &&
        get(row, 'feeNoteMission.missionPostPone.status', null) ===
          'PENDING')) &&
    get(row, 'status', '') === 'PENDING'
  ) {
    return 'ETAPE EN ATTENTE';
  } else if (couldAddInvoiceInfo(row, listings)) {
    return 'DONNEES DE LA FACTURE VIDES';
  } else if (
    checkInvoiceInfo(get(row, 'invoiceFeeNote', {})) &&
    get(row, 'status', '') === 'PENDING' &&
    (featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE_EXPERT)
      ? true
      : get(
          get(listings, 'intervenants')?.find(
            (el: any) => el.ItemKey === get(row, 'codeIntervenant', null),
          ),
          'ItemType',
        ) != DOCTOR_ITEM_TYPE) &&
    ((get(row, 'step') != 'PV' &&
      new Date(get(row, 'createdAt')) >=
        new Date(moment(LIMIT_DATE_INVOICE).format('DD-MM-YYYY'))) ||
      (get(row, 'step') === 'PV' &&
      get(row, 'claim.profilOpenner', null) === PROFIL_OPENNER_GPO
        ? get(row, 'claim.pvHolder.pvHolderTypeId', null) != 3 &&
          ((!isNil(get(row, 'claim.receptionDatePv', null)) &&
            new Date(get(row, 'claim.receptionDatePv')) >=
              new Date(moment(LIMIT_DATE_INVOICE).format('DD-MM-YYYY'))) ||
            (isNil(get(row, 'claim.receptionDatePv', null)) &&
              new Date(get(row, 'createdAt')) >=
                new Date(moment(LIMIT_DATE_INVOICE).format('DD-MM-YYYY'))))
        : new Date(get(row, 'createdAt')) >=
          new Date(moment(LIMIT_DATE_INVOICE).format('DD-MM-YYYY'))))
  ) {
    return 'DONNEES DE FACTURES INCOMPLETES';
  } else if (
    isNil(get(row, 'firmReference', null)) &&
    isNil(get(row, 'feeNoteMission', null))
  ) {
    return 'REFERENCE CABINET VIDE';
  } else {
    return '';
  }
};

export const isValidatedOrPendingJudgement = (row: any) => {
  return (
    (!isNull(get(row, 'judgementAddDocument.status', null)) &&
      get(row, 'judgementAddDocument.status', null) === STATUS_REJECTED) ||
    get(row, 'judgement.status', null) === 'TO_EDIT' ||
    get(row, 'judgement.status', null) === STATUS_REJECTED ||
    (get(row, 'step') === 'PV' &&
      get(row, 'claim.status') === STATUS_REJECTED) ||
    (!isNil(get(row, 'feeNoteMission.missionExpertiseVictim.status', null)) &&
      get(row, 'feeNoteMission.missionExpertiseVictim.status', null) ===
        STATUS_REJECTED) ||
    (!isNil(get(row, 'feeNoteMission.missionExpertiseVehicle.status', null)) &&
      get(row, 'feeNoteMission.missionExpertiseVehicle.status', null) ===
        STATUS_REJECTED) ||
    (!isNil(get(row, 'feeNoteMission.missionPostPone.status', null)) &&
      get(row, 'feeNoteMission.missionPostPone.status', null) ===
        STATUS_REJECTED)
  );
};

export const shouldDisplayPinEdit = (
  row: any,
  isManager: any,
  listings: any,
) => {
  if (
    ((row.step === FEE_NOTE_STEP.EXPERTISE_CONSEIL_APPRECIATION &&
      row.status === STATUS_PENDING &&
      userPrivileges.userHasPrivilege(PRIVILEGES.ISMANAGER)) ||
      (!isValidatedOrPendingJudgement(row) &&
        row.status === STATUS_REJECTED)) &&
    isManager
  ) {
    return true;
  } else {
    return false;
  }
};

export const checkInvoiceInfo = (invoiceInfo: any) => {
  return (
    isNil(get(invoiceInfo, 'invoiceNumber', null)) ||
    isNil(get(invoiceInfo, 'url', null)) ||
    isNil(get(invoiceInfo, 'invoiceDate', null)) ||
    isNil(get(invoiceInfo, 'receptionDate', null)) ||
    get(invoiceInfo, 'url', null) === '' ||
    get(invoiceInfo, 'invoiceNumber', null) === ''
  );
};

export const formatJudgementDate = (feeNote: any) => {
  if (get(feeNote, 'step') === 'PV') {
    if (get(feeNote, 'claim.profilOpenner', null) === PROFIL_OPENNER_GPO) {
      if (!isNil(get(feeNote, 'claim.receptionDatePv', null))) {
        return get(feeNote, 'claim.receptionDatePv');
      } else {
        return get(feeNote, 'createdAt');
      }
    } else {
      return get(feeNote, 'createdAt');
    }
  } else {
    return get(feeNote, 'judgementDate');
  }
};

export const renderInvoiceFeeNoteControlAction = (row: any, listings: any) => {
  return (
    (featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE) &&
      (isNil(get(row, 'invoiceFeeNote', null)) ||
        checkInvoiceInfo(get(row, 'invoiceFeeNote', {}))) &&
      isNil(get(row, 'costs', null)) &&
      isNil(get(row, 'feeNoteMission')) &&
      (get(row, 'step') === 'PV' &&
      get(row, 'claim.profilOpenner', null) === PROFIL_OPENNER_GPO
        ? get(row, 'claim.pvHolder.pvHolderTypeId', null) != 3 &&
          ((!isNil(get(row, 'claim.receptionDatePv', null)) &&
            new Date(get(row, 'claim.receptionDatePv')) >=
              new Date(moment(LIMIT_DATE_INVOICE).format('DD-MM-YYYY'))) ||
            (isNil(get(row, 'claim.receptionDatePv', null)) &&
              new Date(get(row, 'claim.createdAt')) >=
                new Date(moment(LIMIT_DATE_INVOICE).format('DD-MM-YYYY'))))
        : new Date(get(row, 'claim.createdAt')) >=
          new Date(moment(LIMIT_DATE_INVOICE).format('DD-MM-YYYY')))) ||
    (featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE) &&
      (isNil(get(row, 'invoiceFeeNote', null)) ||
        checkInvoiceInfo(get(row, 'invoiceFeeNote', {}))) &&
      isNil(get(row, 'costs', null)) &&
      isNil(get(row, 'feeNoteMission')) &&
      get(row, 'step') != 'PV' &&
      new Date(get(row, 'createdAt')) >=
        new Date(moment(LIMIT_DATE_INVOICE).format('DD-MM-YYYY')))
  );
};

export const couldAddInvoiceInfo = (row: any, listings: any) => {
  return (
    isNil(get(row, 'invoiceFeeNote', null)) &&
    get(row, 'status') != STATUS_VALIDATED &&
    (featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE_EXPERT)
      ? true
      : Number(
          get(
            get(listings, 'intervenants')?.find(
              (el: any) => el.ItemKey === get(row, 'codeIntervenant', null),
            ),
            'ItemType',
          ),
        ) != DOCTOR_ITEM_TYPE && isNil(get(row, 'feeNoteMission', null))) &&
    ((get(row, 'step') != 'PV' &&
      new Date(get(row, 'createdAt')) >=
        new Date(moment(LIMIT_DATE_INVOICE).format('DD-MM-YYYY'))) ||
      (get(row, 'step') === 'PV' &&
      get(row, 'claim.profilOpenner', null) === PROFIL_OPENNER_GPO
        ? get(row, 'claim.pvHolder.pvHolderTypeId', null) != 3 &&
          ((!isNil(get(row, 'claim.receptionDatePv', null)) &&
            new Date(get(row, 'claim.receptionDatePv')) >=
              new Date(moment(LIMIT_DATE_INVOICE).format('DD-MM-YYYY'))) ||
            (isNil(get(row, 'claim.receptionDatePv', null)) &&
              new Date(get(row, 'createdAt')) >=
                new Date(moment(LIMIT_DATE_INVOICE).format('DD-MM-YYYY'))))
        : new Date(get(row, 'createdAt')) >=
          new Date(moment(LIMIT_DATE_INVOICE).format('DD-MM-YYYY'))))
  );
};

export const formatCostToAdd = (feeNote: any, listing: any) => {
  const intervenantInfo = !isEmpty(
    get(listing, 'intervenants', [])?.find(
      (el: any) => el.ItemKey === get(feeNote, 'codeIntervenant'),
    ),
  )
    ? get(listing, 'intervenants', [])?.find(
        (el: any) => el.ItemKey === get(feeNote, 'codeIntervenant'),
      )
    : get(listing, 'inactiveIntervenants', [])?.find(
        (el: any) => el.ItemKey === get(feeNote, 'codeIntervenant'),
      );
  return {
    feeNoteToValidate: {
      step: get(feeNote, 'step'),
      isMissionFeeNote: false,
      codeIntervenant: get(feeNote, 'codeIntervenant'),
      beneficiary: get(intervenantInfo, 'ItemDescription'),
      createdBy: currentUserStorage?.get()?.username,
      invoiceDate: null,
      receptionDate: null,
      InvoiceDate: null,
      InvoiceReceptionDate: null,
      contractorCode: get(feeNote, 'codeIntervenant'),
      claimExtCode: get(feeNote, 'claim.claimNumber'),
      contractorTypeCode: get(intervenantInfo, 'ItemType'),
      Amount: get(feeNote, 'costs'),
      updateDate: new Date(),
      townCode: get(intervenantInfo, 'townCode', ''),
      address: get(intervenantInfo, 'address', ''),
      linkToBeneficiaryCode:
        get(intervenantInfo, 'ItemType') === DEFAULT_PROVIDER_CODE
          ? DEFAULT_LINK_PROVIDER
          : DEFAULT_LINK_BENEFICIARY_CODE,
      judgementDate: get(feeNote, 'judgementDate'),
      ...getPaymentForCosts(listing, feeNote),
      documentId: 88,
      isInboxesActive: featureService.hasFeature(
        FEATURES.ATTRIBUTION_INBOXES_MANAGER,
      ),
      isTrackingActive: featureService.hasFeature(
        FEATURES.TRACKING_ACTIONS_USER,
      ),
      isStatusManagement: featureService.hasFeature(FEATURES.STATUS_MANAGEMENT),
    },
    step: get(feeNote, 'step'),
    username: currentUserStorage?.get()?.username,
    isMissionFeeNote: false,
    costs: get(feeNote, 'costs'),
    codeIntervenant: get(feeNote, 'codeIntervenant'),
    beneficiary: get(intervenantInfo, 'ItemDescription'),
    claimId: get(feeNote, 'claimId'),
    claimNumber: get(feeNote, 'claim.claimNumber'),
    status: STATUS_VALIDATED,
    document: get(feeNote, 'document'),
    isTrackingActive: featureService.hasFeature(FEATURES.TRACKING_ACTIONS_USER),
  };
};

export const couldEditOpeningFeeNote = (row: any) => {
  return featureService.hasFeature(FEATURES.EVOLUTION_P3)
    ? (get(row, 'step') != PROCEDURE_STEPS.PV &&
        userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER)) ||
        (get(row, 'step') === PROCEDURE_STEPS.PV &&
          userPrivileges.userHasPrivilege(PRIVILEGES.ISOPENINGMANAGER)) ||
        String(row.codeIntervenant) ===
          currentIntervenantStorage.get()?.sagis_code
    : true;
};

export const couldEditInvoices = (row: any) => {
  return featureService.hasFeature(FEATURES.EVOLUTION_P3)
    ? (get(row, 'step') != PROCEDURE_STEPS.PV &&
        userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER)) ||
        (get(row, 'step') === PROCEDURE_STEPS.PV &&
          userPrivileges.userHasPrivilege(PRIVILEGES.ISOPENINGMANAGER)) ||
        (String(row.codeIntervenant) ===
          currentIntervenantStorage.get()?.sagis_code &&
          get(row, 'status') != GLOBAL_STATUS.REJECTED)
    : true;
};

export const formatUpdateInvoiceFeeNote = (
  invoiceFeeNoteId: number | null,
  payload: any,
) => {
  return {
    id: invoiceFeeNoteId,
    codeIntervenant: get(payload, 'selectedFeeNote.codeIntervenant'),
    invoiceDate:
      payload.invoiceDate === 'Invalid date' ? null : payload.invoiceDate,
    receptionDate:
      payload.invoiceReceptionDate === 'Invalid date'
        ? null
        : payload.invoiceReceptionDate,
    createdBy: currentIntervenantStorage?.get()?.preferred_username
      ? currentIntervenantStorage?.get()?.preferred_username
      : currentUserStorage?.get()?.username,
    invoiceNumber: payload.invoiceNumber,
    isInboxesActive: featureService.hasFeature(
      FEATURES.ATTRIBUTION_INBOXES_MANAGER,
    ),
    isLawyer: currentIntervenantStorage?.get()?.preferred_username
      ? true
      : false,
    ...payload.invoiceDocument,
    isIndexed: false,
    isVisible: true,
    feeNoteId: get(payload, 'selectedFeeNote.id'),
    isLawyerInboxesActive: featureService.hasFeature(FEATURES.LAWYER_INBOXES),
  };
};

export const formaAddInvoiceFeeNote = (payload: any) => {
  return {
    feeNoteId: get(payload, 'selectedFeeNote.id'),
    codeIntervenant: get(payload, 'selectedFeeNote.codeIntervenant'),
    invoiceDate:
      payload.invoiceDate === 'Invalid date' ? null : payload.invoiceDate,
    receptionDate:
      payload.invoiceReceptionDate === 'Invalid date'
        ? null
        : payload.invoiceReceptionDate,
    createdBy: currentIntervenantStorage?.get()?.preferred_username
      ? currentIntervenantStorage?.get()?.preferred_username
      : currentUserStorage?.get()?.username,
    invoiceNumber: payload.invoiceNumber,
    isInboxesActive: featureService.hasFeature(
      FEATURES.ATTRIBUTION_INBOXES_MANAGER,
    ),
    isLawyer: currentIntervenantStorage?.get()?.preferred_username
      ? true
      : false,
    ...payload.invoiceDocument,
    isLawyerInboxesActive: featureService.hasFeature(FEATURES.LAWYER_INBOXES),
  };
};

export const isPendingFeeNote = (row: any) => {
  return row.status === STATUS_PENDING;
};

export const constructExceptionnelFeeNoteToAdd = (
  feeNote: FeeNoteType,
  isManager: boolean,
  invoiceNumber: string | null,
  invoiceDate: string | null,
  invoiceReceptionDate: string | null,
) => {
  return {
    ...feeNote,
    invoiceFeeNote: {
      codeIntervenant: feeNote.codeIntervenant,
      createdBy: isManager
        ? currentUserStorage?.get()?.username
        : currentIntervenantStorage?.get() &&
          currentIntervenantStorage?.get()?.preferred_username,
      invoiceNumber: invoiceNumber,
      invoiceDate: invoiceDate === 'Invalid date' ? null : invoiceDate,
      receptionDate: isManager
        ? invoiceReceptionDate
        : moment().format('YYYY-MM-DD'),
      url: feeNote?.document?.url,
      name: DOCUMENT + ' 1',
      type: DOCUMENT_TYPES.INVOICE_DOCUMENT,
      isIndexed: false,
    },
  };
};

export const constructUrlInvoice = (url: string) => {
  const baseApiPath = requestUtils.getApiBasePath();
  return `${baseApiPath}/corporeal/v1/upload-documents?url=${url}`;
};

export const renderAmountTtc = (row: any) => {
  return (isNull(row.costs) &&
    new Date(moment(get(row, 'createdAt', null)).format('YYYY-MM-DD')) <
      new Date(moment(LIMIT_DATE_INVOICE).format('DD-MM-YYYY'))) ||
    (isNull(row.costs) &&
      (!isNil(get(row, 'feeNoteMission.mission.reference', null)) ||
        !isEmpty(get(row, 'feeNoteMission.missionExpertiseVictim', {})) ||
        !isEmpty(get(row, 'feeNoteMission.missionExpertiseVehicle', {})))) ||
    (isNull(row.costs) &&
      (!isNil(get(row, 'invoiceFeeNote.invoiceDate', null)) ||
        (new Date(moment(get(row, 'createdAt', null)).format('YYYY-MM-DD')) >=
          new Date(moment(LIMIT_DATE_INVOICE).format('DD-MM-YYYY')) &&
          !isNil(get(row, 'invoiceFeeNote.invoiceDate', null)))))
    ? row.amountTtc
      ? dhAmount(row.amountTtc)
      : '-'
    : isNull(row.costs) &&
      isNil(get(row, 'invoiceFeeNote.invoiceDate', null)) &&
      new Date(moment(get(row, 'createdAt', null)).format('YYYY-MM-DD')) >=
        new Date(moment(LIMIT_DATE_INVOICE).format('DD-MM-YYYY'))
    ? 'En attente de facture'
    : '-';
};

export const renderAmountHt = (row: any) => {
  return (isNull(row.costs) &&
    new Date(moment(get(row, 'createdAt', null)).format('YYYY-MM-DD')) <
      new Date(moment(LIMIT_DATE_INVOICE).format('DD-MM-YYYY'))) ||
    (isNull(row.costs) &&
      (!isNil(get(row, 'feeNoteMission.mission.reference', null)) ||
        !isEmpty(get(row, 'feeNoteMission.missionExpertiseVictim', {})) ||
        !isEmpty(get(row, 'feeNoteMission.missionExpertiseVehicle', {})))) ||
    (isNull(row.costs) &&
      (!isNil(get(row, 'invoiceFeeNote.invoiceDate', null)) ||
        (new Date(moment(get(row, 'createdAt', null)).format('YYYY-MM-DD')) >=
          new Date(moment(LIMIT_DATE_INVOICE).format('DD-MM-YYYY')) &&
          !isNil(get(row, 'invoiceFeeNote.invoiceDate', null)))))
    ? row.amountHt
      ? dhAmount(row.amountHt)
      : '-'
    : isNull(row.costs) &&
      isNil(get(row, 'invoiceFeeNote.invoiceDate', null)) &&
      new Date(moment(get(row, 'createdAt', null)).format('YYYY-MM-DD')) >=
        new Date(moment(LIMIT_DATE_INVOICE).format('DD-MM-YYYY'))
    ? 'En attente de facture'
    : '-';
};
